import React from 'react'
import { Editor } from '@tinymce/tinymce-react'
import { SanitizeHtml } from './sanitizeHtml'

export default function RichTextEditor({ value, onChange, height = '100vh', placeholder }) {
  
  const handleEditorChange = (content, editor) => {
    // Sanitize content before passing it up
    const updatedHtml = SanitizeHtml(content)
    onChange(updatedHtml)
  }

  return (
    <Editor
      tinymceScriptSrc='/tinymce/tinymce.min.js'
      value={value} // Use 'value' for controlled component behavior
      onEditorChange={handleEditorChange}
      init={{
        height: height,
        selector: 'textarea#editable',
        menubar: true, // Enable menubar for more options
        plugins:
          'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount linkchecker code insertdatetime directionality fullscreen',
        toolbar:
          'undo redo | code | blocks fontfamily fontsize | bold italic underline strikethrough | numlist bullist indent outdent | fullscreen | align lineheight | link image media table | emoticons charmap | removeformat | insertdatetime | ltr rtl |',
        font_family_formats:
          'Arial=arial,helvetica,sans-serif;Times New Roman=times new roman,times,serif;Kruti Dev 010=Kruti Dev 010,arial,sans-serif;Poppins=Poppins,helvetica,sans-serif;Helvetica=helvetica,sans-serif',
        placeholder: placeholder,
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        promotion: false // Disable upgrade promotion
      }}
    />
  )
}
